import { render } from "./CartView.vue?vue&type=template&id=47489512"
import script from "./CartView.vue?vue&type=script&lang=js"
export * from "./CartView.vue?vue&type=script&lang=js"
script.render = render

export default script